import {
  ITargetArea,
  IContinent,
  ILocationType,
  IRequiredEquipment,
} from '@ifit/gateway-workout-store';
import { IFilter } from '../helpers/quickFiltersStore';
import {
  lessThanMinutes,
  rangeOfMinutes,
  greaterThanMinutes,
  onlyCompletedText,
  excludeCompletedText,
  intensityLevelBeginner,
  intensityLevelIntermediate,
  intensityLevelAdvanced,
} from './filter-translations';
import i18n from './index';
import { seriesTitle, workoutsTitle } from './translations';

export const targetAreas: Record<ITargetArea, () => string> = {
  [ITargetArea.Back]: () =>
    i18n._translate('Back', {
      context:
        'The area of the body targeted for improvement by a particular workout.',
    }),
  [ITargetArea.Chest]: () =>
    i18n._translate('Chest', {
      context:
        'The area of the body targeted for improvement by a particular workout.',
    }),
  [ITargetArea.Arms]: () =>
    i18n._translate('Arms', {
      context:
        'The area of the body targeted for improvement by a particular workout.',
    }),
  [ITargetArea.Shoulders]: () =>
    i18n._translate('Shoulders', {
      context:
        'The area of the body targeted for improvement by a particular workout.',
    }),
  [ITargetArea.Glutes]: () =>
    i18n._translate('Glutes', {
      context:
        'The area of the body targeted for improvement by a particular workout.',
    }),
  [ITargetArea.Legs]: () =>
    i18n._translate('Legs', {
      context:
        'The area of the body targeted for improvement by a particular workout.',
    }),
  [ITargetArea.Core]: () =>
    i18n._translate('Core', {
      context:
        'The area of the body targeted for improvement by a particular workout.',
    }),
  [ITargetArea.TotalBody]: () =>
    i18n._translate('Total Body', {
      context:
        'The area of the body targeted for improvement by a particular workout.',
    }),
  [ITargetArea.UpperBody]: () =>
    i18n._translate('Upper Body', {
      context:
        'The area of the body targeted for improvement by a particular workout.',
    }),
  [ITargetArea.Abs]: () =>
    i18n._translate('Abs', {
      context:
        'The area of the body targeted for improvement by a particular workout.',
    }),
};

export const continents: Record<IContinent, () => string> = {
  [IContinent.NorthAmerica]: () =>
    i18n._translate('North America', {
      context: 'The geographical location of the selected Workout.',
    }),
  [IContinent.SouthAmerica]: () =>
    i18n._translate('South America', {
      context: 'The geographical location of the selected Workout.',
    }),
  [IContinent.Europe]: () =>
    i18n._translate('Europe', {
      context: 'The geographical location of the selected Workout.',
    }),
  [IContinent.Africa]: () =>
    i18n._translate('Africa', {
      context: 'The geographical location of the selected Workout.',
    }),
  [IContinent.Asia]: () =>
    i18n._translate('Asia', {
      context: 'The geographical location of the selected Workout.',
    }),
  [IContinent.Oceania]: () =>
    i18n._translate('Oceania', {
      context: 'The geographical location of the selected Workout.',
    }),
  [IContinent.Antarctica]: () =>
    i18n._translate('Antarctica', {
      context: 'The geographical location of the selected Workout.',
    }),
};

export const locationTypes: Record<ILocationType, () => string> = {
  [ILocationType.Forest]: () =>
    i18n._translate('Forest', {
      context: 'The location type of the selected Workout.',
    }),
  [ILocationType.Beach]: () =>
    i18n._translate('Beach', {
      context: 'The location type of the selected Workout.',
    }),
  [ILocationType.Mountains]: () =>
    i18n._translate('Mountains', {
      context: 'The location type of the selected Workout.',
    }),
  [ILocationType.Desert]: () =>
    i18n._translate('Desert', {
      context: 'The location type of the selected Workout.',
    }),
  [ILocationType.City]: () =>
    i18n._translate('City', {
      context: 'The location type of the selected Workout.',
    }),
  [ILocationType.Savannahs]: () =>
    i18n._translate('Savannahs', {
      context: 'The location type of the selected Workout.',
    }),
  [ILocationType.Landmarks]: () =>
    i18n._translate('Landmarks', {
      context: 'The location type of the selected Workout.',
    }),
  [ILocationType.Studio]: () =>
    i18n._translate('Studio', {
      context: 'The location type of the selected Workout.',
    }),
  [ILocationType.Waterfront]: () =>
    i18n._translate('Waterfront', {
      context: 'The location type of the selected Workout.',
    }),
};

export const requiredEquipments: Record<IRequiredEquipment, () => string> = {
  [IRequiredEquipment.Barbell]: () =>
    i18n._translate('Barbell', {
      context: 'The equipment required for a given workout.',
    }),
  [IRequiredEquipment.Barre]: () =>
    i18n._translate('Barre', {
      context: 'The equipment required for a given workout (a ballet barre).',
    }),
  [IRequiredEquipment.Blocks]: () =>
    i18n._translate('Blocks', {
      context:
        'The equipment required for a given workout (a block often used for yoga).',
    }),
  [IRequiredEquipment.Bolster]: () =>
    i18n._translate('Bolster', {
      context:
        'The equipment required for a given workout (a special kind of pillow often used for yoga).',
    }),
  [IRequiredEquipment.Bench]: () =>
    i18n._translate('Bench', {
      context:
        'The equipment required for a given workout (a weight bench where you can lay on your back while lifting weights with your arms).',
    }),
  [IRequiredEquipment.Dumbbells]: () =>
    i18n._translate('Dumbbells', {
      context: 'The equipment required for a given workout.',
    }),
  [IRequiredEquipment.ExerciseBall]: () =>
    i18n._translate('Exercise Ball', {
      context: 'The equipment required for a given workout.',
    }),
  [IRequiredEquipment.JumpRope]: () =>
    i18n._translate('Jump Rope', {
      context: 'The equipment required for a given workout.',
    }),
  [IRequiredEquipment.Kettlebell]: () =>
    i18n._translate('Kettlebell', {
      context: 'The equipment required for a given workout.',
    }),
  [IRequiredEquipment.Mat]: () =>
    i18n._translate('Mat', {
      context:
        'The equipment required for a given workout (an exercise mat placed on the ground).',
    }),
  [IRequiredEquipment.MedicineBall]: () =>
    i18n._translate('Medicine Ball', {
      context: 'The equipment required for a given workout.',
    }),
  [IRequiredEquipment.MiniBands]: () =>
    i18n._translate('Mini Bands', {
      context: 'The equipment required for a given workout.',
    }),
  [IRequiredEquipment.ResistanceBands]: () =>
    i18n._translate('Resistance Bands', {
      context: 'The equipment required for a given workout.',
    }),
};

export function translateTargetArea(targetArea: ITargetArea | string): string {
  const fn = targetAreas[targetArea];
  if (fn !== undefined) {
    return fn();
  }
  return targetArea;
}

export function translateContinent(continent: IContinent | string): string {
  const fn = continents[continent];
  if (fn !== undefined) {
    return fn();
  }
  return continent;
}

export function translateLocationType(
  locationtype: ILocationType | string,
): string {
  const fn = locationTypes[locationtype];
  if (fn !== undefined) {
    return fn();
  }
  return locationtype;
}

export function translateRequiredEquipment(
  requiredEquipment: IRequiredEquipment | string,
): string {
  const fn = requiredEquipments[requiredEquipment];
  if (fn !== undefined) {
    return fn();
  }
  return requiredEquipment;
}

export function translateTimeRange(range: string): string {
  const secondsLimits = range.split('-');
  const [minMinutes, maxMinutes] = secondsLimits.map(
    seconds => Number(seconds) / 60,
  );
  if (!minMinutes) {
    if (maxMinutes < 20) {
      return lessThanMinutes(20);
    }
    return lessThanMinutes(maxMinutes);
  } else if (maxMinutes > 166) {
    return greaterThanMinutes(minMinutes);
  } else {
    return rangeOfMinutes(minMinutes, maxMinutes);
  }
}

export function translateHasCompleted(value: string): string {
  if (value === 'true') {
    return onlyCompletedText();
  } else {
    return excludeCompletedText();
  }
}

export function translateIntensity(intensity: string): string {
  switch (intensity) {
    case 'beginner':
      return intensityLevelBeginner();
    case 'intermediate':
      return intensityLevelIntermediate();
    case 'advanced':
    default:
      return intensityLevelAdvanced();
  }
}

export function translateWorkoutAndSeries(type: string): string {
  return type === 'program' ? seriesTitle() : workoutsTitle();
}

export function translateFilter(filter: IFilter): string {
  switch (filter.type) {
    case 'categories':
    case 'languages':
      // TODO: We should look at the filterOptions response from the server to translate these, since they're dynamic.
      return filter.display;
    case 'trainerIds':
      return filter.display;
    case 'difficultyScores':
      return translateIntensity(filter.filter);
    case 'targetAreas':
      return translateTargetArea(filter.filter);
    case 'locationTypes':
      return translateLocationType(filter.filter);
    case 'requiredEquipment':
      return translateRequiredEquipment(filter.filter);
    case 'timeRanges':
      return translateTimeRange(filter.filter);
    case 'hasCompleted':
      return translateHasCompleted(filter.filter);
    case 'continents':
      return translateContinent(filter.filter);
    case 'includedEntities':
      return translateWorkoutAndSeries(filter.filter);
    default:
      if (window.NODE_ENV === 'development') {
        console.log(
          'WARNING: Untranslated filter detected:',
          filter.type,
          filter.filter,
          filter.display,
        );
      }
      return filter.display;
  }
}
